const invoiceFilterTypes = {
  outgoingInvoice: 3, // sale invoice
  incommingInvoice: 2 // buy invoice
};

export default invoiceFilterTypes;
